import { useLocale } from '../../preferences/i18n/LocaleProvider';

interface DeleteNodeConfirmDialogProps {
	nodeName: string;
	onConfirm(): void;
	onCancel(): void;
}

export function DeleteNodeConfirmDialog({
	nodeName,
	onConfirm,
	onCancel,
}: DeleteNodeConfirmDialogProps) {
	const { t } = useLocale();

	return (
		<div role="dialog" aria-modal="true" aria-label={t('deleteNodeConfirmTitle')} className="floating-panel">
			<div className="hud-stack" style={{ minWidth: 320, maxWidth: 380 }}>
				<h2 style={{ margin: 0, fontSize: '1rem' }}>{t('deleteNodeConfirmTitle')}</h2>
				<p style={{ margin: 0 }}>{formatMessage(t('deleteNodeConfirmPrompt'), { name: nodeName })}</p>
				<div className="hud-toolbar" role="group" aria-label={t('deleteNodeConfirmTitle')}>
					<button className="hud-subtle-button" onClick={onConfirm} type="button">
						{t('deleteNodeConfirmAction')}
					</button>
					<button className="hud-subtle-button" onClick={onCancel} type="button">
						{t('cancel')}
					</button>
				</div>
			</div>
		</div>
	);
}

function formatMessage(template: string, values: Record<string, string>): string {
	return Object.entries(values).reduce((message, [key, value]) => message.replace(`{${key}}`, value), template);
}